import { history } from "../../app/Router";
import { initializeUserSession } from "../../app/session";
import { AppDispatch, RootState } from "../../app/store";
import { anonSessionActions } from "./slice/anonSessionSlice";
import { authedSessionActions } from "./slice/authedSessionSlice";
import { notificationActions } from "./slice/notificationSlice";
import { questionnaireActions } from "./slice/questionnaireSlice";
import { userAnswersActions } from "./slice/userAnswersSlice";
import { userPlanActions } from "./slice/userPlanSlice";
import { createAction } from "@reduxjs/toolkit";

export const resetStateForTesting = createAction<Partial<RootState>>(
  "resetStateForTesting",
);

export function resetEntityStores() {
  return (dispatch: AppDispatch) => {
    dispatch(userPlanActions.resetUserPlan());
    dispatch(userAnswersActions.resetUserAnswers());
    dispatch(questionnaireActions.resetQuestionnaire());
  };
}

export function fullyLogoutUser() {
  return (dispatch: AppDispatch) => {
    dispatch(resetEntityStores());
    dispatch(authedSessionActions.logOut());
    dispatch(anonSessionActions.clearAnonSession());
    history.push("/");
    initializeUserSession();
  };
}

export function userSessionExpired() {
  return (dispatch: AppDispatch) => {
    dispatch(fullyLogoutUser());
    dispatch(notificationActions.addNotification({ id: "sessionExpired" }));
  };
}

export const commonActions = {
  fullyLogoutUser,
  resetEntityStores,
};
